export const ImagePlaceholder: React.FC<React.SVGProps<SVGSVGElement>> = props => (
	<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.2683 13.5458C14.274 13.5458 15.9 11.9206 15.9 9.91577C15.9 7.91097 14.274 6.28577 12.2683 6.28577C10.2625 6.28577 8.63656 7.91097 8.63656 9.91577C8.63656 11.9206 10.2625 13.5458 12.2683 13.5458ZM35.2076 30.1218C35.6108 30.6376 35.2433 31.3914 34.5886 31.3914H20.2395C20.2393 31.3914 20.2392 31.3916 20.2393 31.3917C20.2394 31.3918 20.2394 31.392 20.2392 31.392H3.03843C2.37475 31.392 2.01002 30.6201 2.43144 30.1074L10.2006 20.6553C10.5149 20.2729 11.1002 20.2729 11.4146 20.6553L15.1538 25.2045C15.4731 25.593 16.0701 25.5857 16.3798 25.1895L23.2469 16.4049C23.5615 16.0025 24.1703 16.0025 24.4849 16.4049L35.2076 30.1218Z"
			fill="currentColor"
		/>
	</svg>
);
